module.exports = __webpack_public_path__ + "static/media/race_share.68baedf0.jpg";